import { createApp } from 'vue';
import App from './App.vue';
import 'normalize.css';
// import { createPinia } from 'pinia';
import axios from 'axios';
import 'ant-design-vue/dist/reset.css';
import { i18n } from './i18n/i18n';

import { router } from './router';
import { mainPinia } from './store';

// import 'highlight.js/styles/stackoverflow-light.css';
// import hljs from 'highlight.js/lib/core';
// import json from 'highlight.js/lib/languages/json';
// import hljsVuePlugin from '@highlightjs/vue-plugin';

// hljs.registerLanguage('json', json);

const app = createApp(App);

app.use(mainPinia);
app.use(i18n);
// app.use(hljsVuePlugin);
app.use(router);
app.mount('#app');

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.axios = axios;
